/**
 * Helper function to convert props to HTML attributes string
 */
const propsToAttributes = (props: Record<string, any>): string => {
  return Object.entries(props)
    .map(([key, value]) => {
      if (value === undefined) return "";
      if (value === "true") return ` ${key}`;
      if (value === "false") return "";
      return ` ${key}="${value}"`;
    })
    .join("");
};

export default propsToAttributes;
